import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";

import ArticleCard from "./ArticleCard";
import ArticleModal from "./ArticleModal";
import { getArticles } from "./articlesService";

const ArticleSection = () => {
  const [articles, setArticles] = useState([]);
  // const navigate = useNavigate();
  const [selectedArticle, setSelectedArticle] = useState(null);

  useEffect(() => {
    const loadArticles = async () => {
      try {
        const latestArticles = await getArticles(); // pega os 3 últimos
        setArticles(latestArticles);
      } catch (error) {
        console.error("Erro ao buscar artigos:", error);
      }
    };

    loadArticles();
  }, []);


  return (
    <section className="py-12 bg-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center">
          Últimos Artigos
        </h2>

         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {articles.slice(0, 4).map(article => (
            <ArticleCard key={article.id} article={article} onOpen={setSelectedArticle}/>
          ))}
        </div>
        {selectedArticle && (
          <ArticleModal article={selectedArticle} onClose={() => setSelectedArticle(null)} />
        )}
      </div>
    </section>
  );
};

export default ArticleSection;
